import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const TrashBinIcon = ({ color = '#000', style = {}, size = 'sm', ...attr }) => {
  return (
    <svg {...iconSizes[size]} style={style} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.00016 2.00004C6.07969 2.00004 5.3335 2.74623 5.3335 3.66671H8.66683C8.66683 2.74623 7.92064 2.00004 7.00016 2.00004ZM10.3335 5.33337H3.66683V12.8334H10.3335V5.33337ZM2.00016 5.33337V14.5H12.0002V5.33337H13.6668V3.66671H10.3335C10.3335 1.82576 8.84111 0.333374 7.00016 0.333374C5.15921 0.333374 3.66683 1.82576 3.66683 3.66671H0.333496V5.33337H2.00016Z" fill={color} />
    </svg>
  );
};

export default TrashBinIcon;
